<template>
  <div>
    <NavBar></NavBar>
    <section class="hero is-medium is-dark is-bold">
      <img src="../assets/banner.jpeg" alt="">
      <!--<div class="hero-body">
        <div class="container">
          <p class="title">
            Elige cuanto queres
          </p>
          <p class="subtitle">
            ¡Bienvenido a la calculadora de PresTarCred!
          </p>
        </div>
      </div>-->
    </section>
    <br>

    <section>
      <div class="tile is-ancestor">
        <div class="tile is-parent">
          <article class="tile is-child notification is-success">
            <div class="content">
              <p class="title">Consulta</p>
              <p class="subtitle">tu crédito aquí!!</p>
              <div class="content">
                <div class="columns">
                  <div class="column">

                    <b-field label="¿Qué tarjeta Tienes?">
                      <b-select
                      placeholder="¿Qué tarjeta tienes?"
                      size="is-medium"
                      expanded rounded
                      @input="someHandler(card_select)"
                      v-model="card_select">
                      >

                      <option  v-for="(item, index) in payment_methods" :value="item.id" >{{ item.name}}</option>


                    </b-select>
                  </b-field>
                  {{ telephone }}
                  <b-field label="¿De cuál banco?">
                    <b-select
                    placeholder="¿De cual banco?"
                    size="is-medium"
                    expanded rounded
                    v-model="bank_select">
                    <option v-for="(item, index) in bank" :value="item.id">{{ item.name}}</option>

                  </b-select>
                </b-field>
                <b-field label="Ingrese tu saldo para compras en un pago">
                  <b-input v-model="quantity" size="is-medium" type="number" placeholder="Ingrese una cantidad" rounded></b-input>
                </b-field>
                <b-field label="Ingrese tu saldo para compras en cuotas">
                  <b-input v-model="quantity_couta" size="is-medium" type="number" placeholder="Ingrese una cantidad" rounded></b-input>
                </b-field>

                <button class="button is-warning is-medium"
                @click="open(quantity, card_select, quantity_couta,bank_select)">
                Consultar
              </button>

            </div>

          </div>
          <!-- Content -->
        </div>
      </div>
    </article>
  </div>
  <div class="tile is-vertical is-8">
    <div class="tile">
      <div class="tile is-parent is-vertical">

        <article class="tile is-child notification is-warning">

          Lo máximo que podes sacar es:

          <b-field label="Cantidad de coutas">
            <b-select  @input="feeSelectInput(feed_select, totalCouta, card_select, bank_select)" size="is-medium" placeholder="Select a character" v-model="feed_select"rounded>
              <option v-for="item in fee" :value="item" >{{ item.installments}}</option>

            </b-select>

          </b-field>

          <nav class="level is-mobile">
            <div class="level-item has-text-centered">
              <div>
                <p class="heading">En un pago</p>

                <div v-if="total === ''">
                  <p class="title">0</p>
                </div>
                <div v-else>
                  <p class="title">{{total}}</p>
                </div>
              </div>
            </div>
            <div class="level-item has-text-centered">
              <div>
                <p class="heading">En coutas</p>
                <div v-if="totalCouta === ''">
                  <p class="title">0</p>
                </div>
                <div v-else>
                  <p class="title">{{couta}}</p>
                </div>
              </div>
            </div>
            <div class="level-item has-text-centered">
              <div>
                <p class="heading">Valor de la Cuota</p>
                <div v-if="coutaPrice === ''">
                  <p class="title">0</p>
                </div>
                <div v-else>
                  <p class="title">{{coutaPrice}}</p>
                </div>
              </div>
            </div>
          </nav>
        </article>
      </div>


      <!--<div class="tile is-parent">
      <article class="tile is-child notification is-info">
      <p class="title">Middle tile</p>
      <p class="subtitle">With an image</p>
      <figure class="image is-4by3">
      <img src="https://bulma.io/images/placeholders/640x480.png">
    </figure>
  </article>
</div>-->
</div>

<!--<<div class="tile is-parent">
<article class="tile is-child notification is-danger">
<p class="title">Wide tile</p>
<p class="subtitle">Aligned with the right tile</p>
<div class="content">
</div>
</article>
</div>-->
</div>

</div>
<section class="hero is-medium is-dark is-bold">
  <img src="../assets/banner2.jpeg" alt="">
  <!--<div class="hero-body">
    <div class="container">
      <p class="title">
        Elige cuanto queres
      </p>
      <p class="subtitle">
        ¡Bienvenido a la calculadora de PresTarCred!
      </p>
    </div>
  </div>-->
</section>

</section>

</section>

<footer class="footer">
  <div class="container">
    <div class="content has-text-centered">
      <p>
        <strong>PresTarCred</strong> Creado por: <a href="https://www.linkedin.com/in/abrahamsolorzano/">Abraham Solórzano</a>. Visita nuestra web
        <a href="https://www.prestarcred.com/">PresTarCred</a>. The website content
        is licensed <a href="http://creativecommons.org/licenses/by-nc-sa/4.0/">CC BY NC SA 4.0</a>.
      </p>
    </div>
  </div>
</footer>

</div>

</template>

<script>
import NavBar from '../components/reusable/NavBar.vue'
import Carousel from '../components/reusable/Carousel.vue'
import NoFees from '../components/credits/NoFees.vue'
import Fees from '../components/credits/Fees.vue'


//const token = 'APP_USR-2927642208869156-031016-7dbbbdc90cee57a03ab453cb6e84adf5__B_J__-306085896'


import axios from 'axios';



export default {
  name: 'HelloWorld',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App',
      payment_methods: [
      { name: 'Mercado Pago + Banco Patagonia', id: 'mercadopago_cc' },
      { name: 'American Express', id: 'amex' },
      { name: 'Tarjeta Walmart', id: 'cordial' },
      { name: 'Cencosud', id: 'cencosud' },
      { name: 'Nativa Mastercard', id: 'nativa' },
      { name: 'Diners', id: 'diners' },
      { name: 'Naranja', id: 'naranja' },
      { name: 'Visa', id: 'visa' },
      { name: 'CMR', id: 'cmr' },
      { name: 'Cabal', id: 'cabal' },
      { name: 'Tarjeta Shopping', id: 'tarshop' },
      { name: 'Cordobesa', id: 'cordobesa' },
      { name: 'Argencard', id: 'argencard' },
      { name: 'Mastercard', id: 'master' }
    ],
      quantity: '',
      total: '',
      totalCouta: '',
      fee: '',
      feed_select: '',
      feed_couta: '',
      couta: '',
      bank:'',
      bank_select: '',
      card_select:'',
      telephone: '',
      token: '',
      quantity_couta:'',
      coutaPrice: ''

    }
  },

  created() {


    axios.post(`https://api.mercadolibre.com/oauth/token?grant_type=client_credentials&client_id=7898570282864652&client_secret=yxrMmyQghWZFQB7yBSAKJGlvBgvsDBFb`)
    .then(response => {
      //console.log(response.data)
      // JSON responses are automatically parsed.

      //console.log(response.data["access_token"]);
      this.token = response.data["access_token"]

      
    })
    .catch(e => {
      this.errors.push(e)
    })
    },








  methods: {
    open(quantity, card_select, quantity_couta, bank_select) {

      //console.log("entro");




      //console.log(card_select);

      const loadingComponent = this.$loading.open()

      setTimeout(() => loadingComponent.close(), 1 * 500)
      //Número ingresado por 40% entre 100 esto me devuelve la cantidad que puede sacar la persona
      let percentage = quantity * 40 / 100

      let percentage_couta = quantity_couta * 40 / 100

      const totalCount = parseInt(quantity) - parseInt(percentage)
      const totalCountCouta = parseInt(quantity_couta) - parseInt(percentage_couta)


      this.total = totalCount
      this.totalCouta = totalCountCouta

      //console.log(totalCount);

      axios.get(`https://api.mercadopago.com/v1/payment_methods/installments?access_token=${this.token}&payment_method_id=${card_select}&amount=${totalCountCouta}&issuer.id=${bank_select}`)
      .then(response => {
        console.log(response.data['0'].payer_costs)
        // JSON responses are automatically parsed.
        this.fee = response.data['0'].payer_costs
      })
      .catch(e => {
        this.errors.push(e)
      })
    },

    feeSelectInput(fee, totalCouta, card_select, bank_select) {

      //console.log(fee.installments)

      let selectCouta = fee.installments
      let amount = parseInt(totalCouta) - parseInt(fee.total_amount)
      let totalAmount = parseInt(fee.total_amount) - parseInt(totalCouta)
      let totalCoutaRecalculated = parseInt(totalCouta) - totalAmount

      if (fee.total_amount > totalCouta ) {

          axios.get(`https://api.mercadopago.com/v1/payment_methods/installments?access_token=${this.token}&payment_method_id=${card_select}&amount=${totalCoutaRecalculated}&issuer.id=${bank_select}`)
          .then(response => {
            //console.log(response.data['0'].payer_costs)
            let i = 0
            for (i = 0; i < response.data['0'].payer_costs.length; i++) {
                if (response.data['0'].payer_costs[i].installments == selectCouta) {
                  this.couta = response.data['0'].payer_costs[i].total_amount
                  this.coutaPrice = response.data['0'].payer_costs[i].installment_amount
                }
            }


          })
          .catch(e => {
            this.errors.push(e)
          });


      } else {
        console.log(bank_select);
        axios.get(`https://api.mercadopago.com/v1/payment_methods/installments?access_token=${this.token}&payment_method_id=${card_select}&amount=${totalCouta}&issuer.id=${bank_select}`)
        .then(response => {

          let i = 0
          for (i = 0; i < response.data['0'].payer_costs.length; i++) {
              if (response.data['0'].payer_costs[i].installments == selectCouta) {
                this.couta = response.data['0'].payer_costs[i].total_amount
                this.coutaPrice = response.data['0'].payer_costs[i].installment_amount
              }
          }

        })
        .catch(e => {
          this.errors.push(e)
        })

      }

    },

    someHandler (idCard)  {

      console.log(idCard);

      if  (idCard == "visa"){

        this.telephone = 'Llama Ahora al (011) 43793400 y llena estos datos!'

      }else if ( idCard == "master") {
        this.telephone = 'Llama Ahora al (011) 43487000 y llena estos datos!'

      }else if ( idCard == 'cabal') {
        this.telephone = 'Llama Ahora al (011) 4319 2550 y llena estos datos!'

      }else if ( idCard == 'cmr') {
        this.telephone = 'Llama Ahora al (011) 43605001 y llena estos datos!'

      }else if ( idCard == 'tarshop') {

        this.telephone = 'Llama Ahora al (011) 43605001 y llena estos datos!'
      }else if ( idCard == 'cencosud') {
        this.telephone = 'Llama Ahora al 0810 9999 627 y llena estos datos!'
      }else if ( idCard == 'nativa') {
        this.telephone = 'Llama Ahora al 0810 333 6284 y llena estos datos!'
      }else if ( idCard == 'naranja') {
        this.telephone = 'Llama Ahora al 0810 122 8296 y llena estos datos!'
      }else if ( idCard == 'diners') {
        this.telephone = 'Llama Ahora al 0810 666 3663 y llena estos datos!'
      }else if ( idCard == 'cordobesa') {
        this.telephone = 'Llama Ahora al 0810 222 6267 y llena estos datos!'
      }else {
        this.telephone = 'No hay número teléfonico asociado'
      }


      axios.get(`https://api.mercadopago.com/v1/payment_methods/card_issuers?payment_method_id=${idCard}&access_token=${this.token}`)
      .then(response => {
        console.log(response.data)
        // JSON responses are automatically parsed.
        this.bank = response.data
      })
      .catch(e => {
        this.errors.push(e)
      })


    },

    feeSelect(select) {

      console.log(select);

    }
  },

  components: {
    NavBar,
    Carousel,
    NoFees,
    Fees
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->



// WEBPACK FOOTER //
// src/components/HelloWorld.vue